// extracted by mini-css-extract-plugin
export default {"container":"Question_container__+60HP","content":"Question_content__xzFIn","data":"Question_data__er2sU","qcontent":"Question_qcontent__5Z6l3"};